var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeevaVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30L2 2H6.78049L16 20.2169L25.561 2H30L16 30Z",
    fill: "#EBA800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1464 2H9.85373L16.3415 13.4699L22.1464 2Z",
    fill: "#EBA800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeevaVault);
export default __webpack_public_path__ + "static/media/VeevaVault.a72db4578991b80d79a416fe5bae4161.svg";
export { ForwardRef as ReactComponent };